import { render, staticRenderFns } from "./ModalInstitution.vue?vue&type=template&id=d9d16c50&scoped=true&lang=pug"
import script from "./ModalInstitution.vue?vue&type=script&lang=js"
export * from "./ModalInstitution.vue?vue&type=script&lang=js"
import style0 from "./ModalInstitution.vue?vue&type=style&index=0&id=d9d16c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d16c50",
  null
  
)

export default component.exports